export function getReadableEnum(str: string) {
  return str
    .split('_')
    .join(' ')
    .replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    })
}

export function getDayDifferenceFromToday(postedDate: string, maxDayDiff?: number) {
  const today = new Date()
  const postingDate = new Date(postedDate)
  const timeDifference = today.getTime() - postingDate.getTime()
  // Convert milliseconds to days
  let days = Math.floor(timeDifference / (1000 * 3600 * 24))
  if (maxDayDiff && days > maxDayDiff) {
    days = maxDayDiff
  }
  return days
}

export function getReadableDayDifferenceFromToday(postedDate: string, maxDayDiff?: number) {
  if (!maxDayDiff) {
    maxDayDiff = 7
  }
  const dayDifference = getDayDifferenceFromToday(postedDate, maxDayDiff)
  if (dayDifference === 0) {
    return 'Today'
  }
  if (dayDifference === 1) {
    return 'Yesterday'
  }
  return `${dayDifference} days ago`
}

export function toTitleSlug(title: string) {
  // replace spaces and / with -
  return encodeURIComponent(title.replace(/[\s/]/g, '-'))
}

export function htmlListToArray(htmlContent: string): string[] {
  if (!htmlContent) return []
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = htmlContent

  // Find all <li> elements
  const listItems = tempDiv.querySelectorAll('li')

  // Extract text content from each <li> and store in array
  const result: string[] = Array.from(listItems).map((li) => li.textContent?.trim() || '')

  return result
}

export function arrayToHtmlList(array: string[]): string {
  if (array.length === 0) return ''
  const listItems = array.map((item) => `<li>${escapeHtml(item)}</li>`).join('')
  return `<ul>${listItems}</ul>`
}

export function escapeHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

export function convertDateToIsoFormat(date: Date | string) {
  if (!date) return ''
  if (typeof date === 'string') date = new Date(date)
  return date.toISOString().split('T')[0]
}

export function getOptionTitleFromId(options: { id: string; title: string }[], id: string) {
  const option = options.find((option) => option.id === id)
  return option?.title || ''
}

export function getOptionIdFromTitle(options: { id: string; title: string }[], title: string) {
  const option = options.find((option) => option.title === title)
  return option?.id || ''
}

export function mapSliderRows(arr: any) {
  const length = arr.length
  const rows = length < 15 ? 2 : 3
  const size = Math.ceil(length / rows)
  const newArr = []
  const cycle = Math.ceil(length / size)
  for (let i = 0; i < cycle; i++) {
    newArr.push(arr.slice(i * size, i * size + size))
  }
  return newArr
}

export const getShownEntryInListText = (
  count: number,
  total: number,
  current: number,
  pageSize: number
) => {
  if (!count) return ''
  const left = count % pageSize || pageSize
  const startLeft = pageSize * (total - 1) + 1
  const shownLeft = `${startLeft}—${startLeft + left - 1}`
  const end = current * pageSize
  const start = end - pageSize + 1
  const shown = `${start}—${end}`

  // if 1 page, show the count
  if (total === 1) return `Showing ${count} of ${count} entries`
  // if more than one page, but not the current final page
  else if (current < total) return `Showing ${shown} of ${count} entries`
  // if more than one page, and the current final page
  else return `Showing ${shownLeft} of ${count} entries`
}
